import React from "react"
import { Edit, FormDataConsumer, Button, useRecordContext, SimpleForm, TextInput, SimpleFormIterator, ArrayInput, BooleanInput, useNotify, useTranslate } from "react-admin"
import { useNavigate  } from 'react-router-dom'
import { FileCopy } from "@material-ui/icons"
import Chip from "@material-ui/core/Chip"

export const CopyLink = ({org_id, system_id, ...props}) => {
  const url = `https://delivery.ordering.mekome.net/?org_id=${org_id}&system_id=${system_id}`
  
  return (
    <>
    <Chip label={url}/>
    <Button style={{ margin: '0px 5px 12px 5px' }} onClick={() => { navigator.clipboard.writeText(url)}}>
      העתקת קישור
    </Button>
    </>
  )
}


const OrgEdit = props => {
  const translate = useTranslate()
  const navigate = useNavigate();
  const notify = useNotify()

  const onSuccess = () => {
    notify(translate("customRoot.upload.successMessage"), { type: "success" })
    navigate('/organizations');
  }

  return (
    <Edit {...props} mutationOptions={{ onSuccess }} mutationMode="pessimistic">
      <SimpleForm>
        <TextInput source='id' label='customRoot.users.list.id' />
        <TextInput source='createdAt' label='customRoot.organizations.list.created_at' locales='he-IL' />
        <TextInput source='org_name' label='customRoot.organizations.list.org_name' />
        <TextInput source='display_name' label='customRoot.organizations.list.display_name' />
        <BooleanInput label="customRoot.organizations.list.active" source="active" />
        <ArrayInput source='systems'>
          <SimpleFormIterator disableClear={true}>
          <FormDataConsumer>
            {({ formData, scopedFormData }) =>
              scopedFormData && scopedFormData.system_id ? <CopyLink org_id={formData.id} system_id={scopedFormData.system_id} />: null
            }
            </FormDataConsumer>
          
            <TextInput source='system_id' label='customRoot.users.list.id' />
            <TextInput source='system_name' label='customRoot.organizations.list.display_name' />
            <TextInput source='email' label='customRoot.users.list.email' />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Edit>
  )
}
export default OrgEdit
